{
  "dss": {
    "button": {
      "back": "Tillbaka",
      "cancel": "Avbryt",
      "close": "Stäng",
      "confirmDelete": "Ja, radera",
      "continue": "Fortsätt",
      "logout": "Logga ut",
      "passwordReset": "Återställ lösenord",
      "save": "Spara",
      "verify": "Verifiera"
    },
    "error": {
      "403": "Du har inte åtkomst till den här sidan.",
      "404": "Den här sidan finns inte.",
      "generic": "Ett fel har uppstått. Försök igen senare.",
      "invalidConfirmationLink": "Bekräftelselänken har gått ut eller är ogiltig på annat sätt.",
      "throttling": "För många försök. Den här åtgärden är blockerad ett tag.",
      "title": "Fel",
      "title403": "Åtkomst nekad",
      "title404": "Inte hittad"
    },
    "footer": {
      "imprint": "Ansvarig utgivare",
      "legalEntity": "Andreas Stihl Norden AB, 443 03 Stenkullen",
      "privacy": "Integritetspolicy",
      "terms": "Användarvilkår"
    },
    "label": {
      "CRMAccountNumber": "CRM Account Number",
      "contact": "Kontakta",
      "email": "Email",
      "faq": "FAQ",
      "female": "Ms.",
      "firstname": "FÖRNAMN",
      "help": "Hjälp",
      "language": "SPRÅK",
      "lastname": "EFTERNAMN",
      "male": "Herr.",
      "needHelp": "Behövs hjälp?",
      "newPassword": "Nytt lösenord",
      "newPassword2": "Bekräfta det nya lösenordet",
      "oldPassword": "Aktuellt lösenord",
      "organization": "ORGANISATION",
      "password": "LÖSENORD",
      "required": "krävs",
      "salutation": "HÄLSNINGSFRAS",
      "select": "Vänligen välj"
    },
    "link": {
      "contact": "https://support.stihl.com/sv-SE/websso-contact/",
      "faq": "https://support.stihl.com/sv-SE/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Bekräfta registreringen",
        "wait": "Vänta för att slutföra kontobekräftelsen"
      },
      "otp": {
        "btnResend": "Skicka e-post med verifieringskoden på nytt",
        "msg": {
          "invalidOTP": "Det inmatade engångslösenordet är ogiltigt.",
          "resendFail": "Det gick inte att skicka koden på nytt. Försök igen senare.."
        },
        "spamDetail": "Kontrollera din inkorg och skräppostmapp för att se om du har fått ett e-postmeddelande från STIHL Support. (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Fick du inget e-postmeddelande?",
        "subtitle": "För att kunna fortsätta måste du bekräfta din e-postadress..",
        "title": "Kontrollera ditt användarkonto",
        "txtVerifyMail": "Ange den nya verifieringskoden som vi skickade till din e-postadress. {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Det finns inget att uppdatera.",
          "updateError": "Underlåtenhet att uppdatera personuppgifter.",
          "updated": "Personuppgifter har uppdaterats.",
          "userLoadErr": "Fel vid laddning av användardata. Försök igen senare."
        },
        "secOrganization": "ORGANISATION",
        "secPersonal": "PERSONLIG",
        "secSettings": "ÖNSKADE INSTÄLLNINGAR",
        "title": "PERSONLIG INFO"
      },
      "postPwSet": {
        "info": "Du kan nu använda ditt nya lösenord.",
        "link_name": "Fortsätt att logga in",
        "link_url": "/user/ui/",
        "title": "Ditt lösenord har ändrats"
      },
      "resetPW": {
        "title": "Återställ lösenordet"
      },
      "security": {
        "2fa": {
          "availableMethods": "Tillgängliga 2FA-metoder:",
          "info": "Tvåfaktorsautentisering (2FA) är en säkerhetsfunktion som ger ett extra skyddslager till ditt konto. Det kräver att du använder två metoder för att logga in, istället för bara ett användarnamn och lösenord.",
          "method": {
            "email": "E-post",
            "emailDesc": "Få engångskoder skickade till dig via e-post för att slutföra autentiseringsförfrågningar.",
            "oath": {
              "add": {
                "button": "Registrera Authenticator-appen"
              }
            }
          }
        },
        "authenticator": "Authenticator-app",
        "infoFederatedAccount": "Det här kontot hanteras av din organisations identitetsleverantör, så lösenordet kan inte ändras här. För att ändra ditt lösenord, logga in via din organisations inloggningssida eller kontakta din IT-administratör.",
        "lastUse": "Senast använd kl. {0}.",
        "msg": {
          "invalidPassword": "Ogiltigt lösenord angivet.",
          "passwordAlreadyUsed": "Det går inte att återanvända de senaste 5 lösenorden.",
          "pwUpdateError": "Ett fel uppstod när lösenordet skulle ändras.",
          "pwUpdated": "Lösenordet har ändrats."
        },
        "noDevice": "Inte konfigurerad",
        "oathAdd": {
          "appInfo": "För att göra STIHL-inloggningsprocessen enklare kan du använda Authenticator-appar som {0}, {1}, {2}, etc. för att generera engångslösenord som används som en andra faktor under inloggningsprocessen.<br/>Om du har tappat bort eller glömt din mobila enhet kan du fortfarande använda 2FA-koden som skickas via e-post när som helst.<br/><br/>Följ instruktionerna nedan för att konfigurera din autentiseringsenhet.",
          "badCode": "Ogiltig kod, försök igen.",
          "error": "Ett fel uppstod när autentiseringsenheten skulle registreras.",
          "headScan": "1. Skanna QR-koden med din autentiseringsapp",
          "headVerify": "2. Verifiera koden",
          "infoKey": "installationsnyckel",
          "infoKeyTitle": "Din tvåfaktorshemlighet",
          "infoScanBottom": "Kan inte skanna? Du kan använda {0} för att manuellt konfigurera din autentiseringsenhet app.",
          "infoVerify": "Ange koden som genererats av din autentiseringsapp.",
          "success": "Din autentiseringsenhet har registrerats. Du kan nu använda den för att logga in.",
          "title": "Registrera din tvåfaktorsautentiseringsenhet"
        },
        "oathDelete": {
          "error": "Ett fel uppstod när autentiseringsenheten skulle raderas.",
          "success": "Autentiseringsenheten raderades."
        },
        "passkeys": {
          "about": {
            "info1": "Lösenord är par av kryptografiska nycklar (en offentlig nyckel och en privat nyckel) som lagras av en autentiserare som du kontrollerar. Autentiseraren kan bevisa att en användare är närvarande och är behörig att använda lösenordet. Autentiserare bekräftar auktorisering med en PIN-kod, ett lösenord, en biometrisk kod eller ett enhetslösenord, beroende på autentiserarens funktioner och konfiguration. Autentiserare finns i många former, till exempel en iPhone- eller Android-enhet, Windows Hello, en FIDO2-hårdvarusäkerhetsnyckel eller en lösenordshanterare.",
            "info2": "När du loggar in på STIHL med ett lösenord använder din autentiserare offentlig nyckelkryptografi för att bevisa din identitet för STIHL utan att någonsin skicka lösenordet. Lösenord är bundna till en webbplatsdomän, som stihl-sso.com, och kräver en säker anslutning, vilket innebär att webbläsaren vägrar att autentisera till en liknande nätfiskewebbplats. Dessa egenskaper gör lösenord mycket nätfiskeresistenta och mycket svårare att attackera än SMS eller TOTP 2FA, som kan nätfiskas.",
            "info3": "Molnbaserade nyckelkodstjänster gör det möjligt att synkronisera nyckelnycklar mellan enheter (som Apple-enheter, Android-enheter eller lösenordshanterare) så att de kan användas från fler platser och inte så lätt tappas bort. När du har konfigurerat en synkroniserad nyckelkod på en enhet kan den nyckelkoden användas på flera enheter som använder samma tjänst. Om du till exempel registrerar en nyckelkod med ditt iCloud-konto med din MacBooks Touch ID kan du sedan använda den nyckelkoden med ditt ansikts-, fingeravtryck-, PIN- eller enhetslösenord omväxlande mellan flera enheter som är kopplade till samma iCloud-konto.",
            "title": "Om nyckelnycklar"
          },
          "add": {
            "button": "Lägg till ny nyckelkod",
            "error": "Ett fel uppstod när den nya nyckelkoden skulle läggas till.",
            "success": "En ny nyckelkod lades till."
          },
          "delete": {
            "button": "Ta bort nyckelkod",
            "error": "Ett fel uppstod när den här nyckelkoden skulle raderas.",
            "success": "Lösenkoden raderades."
          },
          "edit": {
            "error": "Ett fel uppstod när lösenordsnyckelns namn skulle sparas.",
            "name": "Lösenordsnyckelns namn",
            "success": "Lösenordsnyckelns namn har uppdaterats.",
            "title": "Ge din lösenordsnyckel ett namn för att skilja den från andra lösenord"
          },
          "info": "Lösenordsnyckeln är ett enkelt och säkert alternativ till lösenord som validerar din identitet med hjälp av beröring, ansiktsigenkänning, ett enhetslösenord eller en PIN-kod.",
          "none": "Ingen lösenordsnyckel konfigurerad.",
          "reallyDelete": "Är du säker på att du vill ta bort lösenordsnyckeln?",
          "registeredPasskeys": "Dina registrerade lösenord:",
          "title": "Lösenord"
        },
        "reallyDeleteDevice": "Är du säker på att du vill ta bort autentiseringsenheten?",
        "secMFA": "Tvåfaktorsautentisering",
        "secPwdChange": "Ändra lösenord",
        "title": "Säkerhet"
      },
      "setPW": {
        "acceptTC": "Bekräfta våra {terms} och läs vår {privacy}.",
        "killSSO": "Invalidera alla aktiva sessioner",
        "msg": {
          "tokenExpired": "Länken eller koden för lösenordet har gått ut. Följ länken för att återställa ditt lösenord: {link}."
        },
        "privacy": "Integritetspolicy för uppgifter",
        "terms": "Villkor och bestämmelser",
        "title": "SKRIV IN NYTT LÖSENORD"
      }
    },
    "validations": {
      "hasDigit": "Måste innehålla en eller flera siffror.",
      "hasLowercase": "Måste innehålla små bokstäver.",
      "hasSpecial": "Måste innehålla ett eller flera specialtecken: {chars}",
      "hasUppercase": "Måste innehålla stora bokstäver.",
      "invalidCharacters": "Innehåller ogiltiga tecken",
      "maxLength": "Högsta tillåtna antal tecken {max}",
      "minLength": "Minsta {min} tecken krävs",
      "notSameAsEmail": "För lik e-postadressen",
      "onlyValidCharactersAllowed": "Endast bokstäver, siffror och mellanslag är tillåtna.",
      "required": "Krävande värde",
      "sameAsPassword": "Lösenordet och bekräftelsen av lösenordet stämmer inte överens",
      "tcAccepted": "Observera våra användarvillkor och sekretesspolicy.",
      "validEmail": "Ogiltig e-postadress.",
      "validOTP": "Ange verifieringskoden."
    }
  }
}
